export default async function ({
                                 store,
                                 params,
                                 error,
                                 app
                               }) {
  await store.dispatch('excursion/fetch', {
    id: params.id,
    params: {
      lang: app.i18n.locale,
      resolution: 'micro',
    }
  })
    .then(() => {
      const excursion = store.getters['excursion/excursion']
      if (!(excursion && excursion?.status === 'active')) {
        error({statusCode: 404})
      }
    })
}
